/**
 * Created by Mark on 18/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    CREATE_ASSIGNMENTS : ENVIRONMENT_CONSTANTS.BASE_URL + '/homeworkController/createHomework',
    EDIT_ASSIGNMENTS : ENVIRONMENT_CONSTANTS.BASE_URL + '/homeworkController/editHomework',
    DUPLICATE_ASSIGNMENTS : ENVIRONMENT_CONSTANTS.BASE_URL + '/homeworkController/duplicateHomework',
    GET_ALL_HOMEWORK : ENVIRONMENT_CONSTANTS.BASE_URL + '/homeworkController/getHomeworkList',
    UPDATE_ALL_HOMEWORK : 'UPDATE_ALL_HOMEWORK',
    UPDATE_ASSIGNMENT   : 'UPDATE_ASSIGNMENT',
    GET_HOMEWORK_DETAIL : ENVIRONMENT_CONSTANTS.BASE_URL + '/homeworkController/getAssignmentDetail',
    DELETE_HOMEWORK: ENVIRONMENT_CONSTANTS.BASE_URL + '/homeworkController/deleteHomework',
    GET_HOMEWORK_FEATURES : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/getFeatures',
    ON_GET_HOMEWORK_FEATURES : 'GET_HOMEWORK_FEATURES'
}



// WEBPACK FOOTER //
// ./src/constants/assignments.js